var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 14,
    x: 6,
    y: 28,
    stroke: "#0033AD",
    strokeWidth: 4,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0033AD",
    strokeLinecap: "round",
    strokeWidth: 4,
    d: "M20 7H10a4 4 0 0 0-4 4v6a4 4 0 0 0 4 4h10"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 14,
    r: 8,
    stroke: "#0033AD",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 14,
    r: 3,
    fill: "#0033AD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManagement);
export default __webpack_public_path__ + "static/media/management.b017e6617bcf6f7d999b34633e24ac6b.svg";
export { ForwardRef as ReactComponent };